import { defineEffect } from '../../../core/effect';

/**
 * **ダメージステップの終わり**（Issue #545。索引 #539）。攻撃宣言が盤に置いた矢印と小さいパネルを消す
 * （`clears`。Issue #552）。**絵は持たない**（初稿の閃光は削除した。ユーザー判断 2026-09-28）。
 * 舞台は攻撃宣言が `'reset'` のまま使うので、ここで戻すものは無い。
 */
export default defineEffect({
  situation: 'damage_step_end',
  role: 'effect',
  label: 'ダメージステップの終わり（矢印を消す）',
  color: '#8a8aa0',
  duration: () => 1,
  clears: () => [{ mark: 'attackArrow' }, { mark: 'battlePanel' }],
}, 'damage_step_end_effect.js');
